import { CollectionEntity } from "@busy-human/gearbox";
export var CalendarEvents;
(function (CalendarEvents) {
    let EventType;
    (function (EventType) {
        EventType["Training"] = "training";
        EventType["TrainingRequest"] = "training-request";
        EventType["Boarding"] = "boarding";
    })(EventType = CalendarEvents.EventType || (CalendarEvents.EventType = {}));
    function Defaults() {
        return {
            userId: '',
            dogId: '',
            startTime: '',
            endTime: '',
            title: '',
            eventType: EventType.Training,
        };
    }
    CalendarEvents.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Defaults();
        }
    }
    CalendarEvents.CollectionClass = CollectionClass;
    CalendarEvents.Collection = new CollectionClass({ path: '/CalendarEvents' });
})(CalendarEvents || (CalendarEvents = {}));
//# sourceMappingURL=index.js.map